export default __webpack_public_path__ + "static/media/mergeAccountsErrorPlaceholder.48812469.svg";